import { CommandType, ScriptCommands } from '../../types/dashboard';

/** Replaced with the project's PostgreSQL major version by CommandsGroup. */
export const PG_VERSION_PLACEHOLDER = '<pg_version>';

const exportSchemaCommand =
  `exsch-pg --pg_version ${PG_VERSION_PLACEHOLDER} --db_name <db_name> -h <host> -p <port> -u <db_user> --db_schema <schema>`;

// Data export, de-identification and query-log capture aren't built for PostgreSQL yet.
const notYetAvailable: CommandType[] = [
  {
    commands: [],
    title: 'Not yet available for PostgreSQL',
    description:
      'This step is coming in a later release. Only the schema export is available for PostgreSQL projects today.',
  },
];

export const staticCommandsDataPOSTGRES: ScriptCommands = {
  saveSchemaToFile: [
    {
      commands: [exportSchemaCommand],
      title: 'Save PostgreSQL Schema to File',
      description:
        'Runs pg_dump of your server\'s major version in Docker after checking the schema can be recreated on RDS. ' +
        'The result is written to output/<db_name>/tables/schema.sql. You are prompted for the password, or set PGPASSWORD first.',
    },
    {
      commands: [`${exportSchemaCommand} --sslrootcert global-bundle.pem`],
      title: 'Optional: verify the server certificate',
      description:
        'The connection is always encrypted. To also verify the server, download the RDS global CA bundle ' +
        '(https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem) and pass it with --sslrootcert.',
    },
  ],
  saveSchemaInstallScript: [
    {
      commands: ['docker --version', 'docker info'],
      title: 'Verify Docker is installed and running',
      description:
        'The PostgreSQL schema exporter runs pg_dump inside Docker, so no PostgreSQL client tools are needed. ' +
        'The first run builds the image, which needs internet access.',
    },
  ],
  saveSchemaDownloadScript: [
    {
      commands: ['cd postgres_schema_exporter'],
      title: 'Move to postgres_schema_exporter directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry install',
        'poetry shell',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: [exportSchemaCommand],
      title: 'Run script',
      description: 'Execute the schema export script for PostgreSQL',
    },
  ],
  createQueryLogSection1: notYetAvailable,
  createQueryLogSection2: notYetAvailable,
  exportDatabase: notYetAvailable,
  downloadScript: notYetAvailable,
  settingUpTheSystemCommandSection1: notYetAvailable,
  settingUpTheSystemCommandSection2: notYetAvailable,
  settingUpTheSystemCommandSection3: notYetAvailable,
  queryLogExtractionSetupCommand1: notYetAvailable,
  queryLogExtractionSetupCommand2: notYetAvailable,
  exportQueryLogsScript: notYetAvailable,
  enableQueryLogsScript: notYetAvailable,
  disableQueryLogsScript: notYetAvailable,
  exportDataAndDeidentificationScript: notYetAvailable,
  shareDeidentifiedFileScript: notYetAvailable,
  queryLogAwsCliInstallScript: notYetAvailable,
};
